// DS: i4.31
import React from 'react';
import IconWrap from '../../IconWrap';
const Link = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.121 15.536a1 1 0 01.078 1.327l-.078.087-1.414 1.414a5 5 0 11-7.071-7.071L7.05 9.879l.087-.078a1 1 0 011.405 1.405l-.077.086-1.415 1.415a3 3 0 004.115 4.364l.128-.121 1.415-1.415.086-.077a1 1 0 011.327.078zm.707-6.364a1 1 0 010 1.414l-4.242 4.242a1 1 0 11-1.414-1.414l4.242-4.242a1 1 0 011.414 0zm3.536-3.536a5 5 0 010 7.071l-1.414 1.414a1 1 0 01-1.492-1.327l.078-.087 1.414-1.414a3 3 0 00-4.115-4.364l-.128.121-1.414 1.414a1 1 0 01-1.327.078l-.087-.078A1 1 0 019.8 7.137l.078-.087 1.414-1.414a5 5 0 017.071 0z"
    })));
Link.displayName = 'Link';
export default Link;
